export default function(products, tagId) {
	if ( ! products ) return false;
	if ( ! Array.isArray(products) ) return false;
	if ( products.length < 1 ) return false;
	if ( ! parseInt(tagId) ) return false;

	return products.filter(product => {
		if (product === null) return false;
		if ( typeof product !== 'object' ) return false;
		if (!Object.prototype.hasOwnProperty.call(product, "tags")) return false;
		return product.tags.includes( tagId );
	})
}